import React, { useEffect, useState } from 'react';
import InsurerListTable from "../Insurer/InsurerTable";
import { getInsurerList } from '../../store/slices/Insurer';
import { useDispatch } from 'react-redux'
import FullPageLoader from '../../common/FullPageLoader';
import { getMasterConfig } from '../../store/slices/common';
import AddEditInsurer from '../Insurer/AddEditInsurer';
import * as HELPER from "../../config/helper";
import { PAGE_NUMBER, ROLE_FEATURES, STATUS_SUCCESS } from '@src/config/constant';
import { useLanguage } from '@src/context/LanguageContext';



export default function InsurerManagement(props: any): ReturnType<React.FC> {
    let [showAddInsPartnerIcon, setShowAddInsPartnerIcon] = useState<boolean>(false)
    let [insurerList, setInsurerList] = useState<any>([])
    let [loading, setLoading] = useState<boolean>(false)
    let [partnerListDropDown,setpartnerListDropDown] = useState<[]>([]);

    const { translations } = useLanguage();

    const dispatch: any = useDispatch()

    const showModalAddInsurance = () => {
        setShowAddInsPartnerIcon(true)
    }

    const hideModalAddInsurance = () => {
        setShowAddInsPartnerIcon(false)
    }
    /**
     * function for API Call
     * fetches Partner Mapping List
     * @param params 
     */
    const getInsurerListData = (params?: { page_number: number }) => {
        setLoading(true)

        let filters = {
            page_number: params?.page_number ?? PAGE_NUMBER
        }

        dispatch(getInsurerList(filters)).then((res: any) => {
            if (res && res.status === STATUS_SUCCESS) {
                const insurerList = res
                setInsurerList(insurerList)
            }
            setLoading(false)

        }).catch((err: Error) => {
            setLoading(false)

        })


    }

    const fetchPartnerMappings = (params: any) => {
        getInsurerListData(params)
    }

    /**
     * API call for rendering static dropdowns 
     */
    // const getConfig = async () => {


    // }

    const handleLoader = (input: boolean) => {
        setLoading(input)
    }

    useEffect(() => {
        getInsurerListData() // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        //api call to fetch static dropdowns
        dispatch(getMasterConfig()).then((res: any) => {
            if (res && res.status === STATUS_SUCCESS) {
                let data: any = res.data || {}
                let { insurance_type, both,partner_list } = data

                //pushing both in dropdowns
                if (both) {
                    // apptype = (apptype && apptype.length) ? [...apptype, both] : []
                    // eslint-disable-next-line
                    insurance_type = (insurance_type && insurance_type.length) ? [...insurance_type, both] : []
                }
                partner_list = (partner_list && partner_list.length) ?  partner_list: []
                setpartnerListDropDown(partner_list)
            }
        }).catch((err: Error) => {
        })
    }, [dispatch])

    return (
        <div className="container-fluid">
            <div className="top-heading financer-lead-heding">
                <h1>{translations.Insurer?.['Insurance Insurer Management'] || translations.commonMsg?.loading}</h1>
                {HELPER.isUserHasAccessPage({permissionID: ROLE_FEATURES['insurance_insurer_management'], accessType: 'edit'}) && <button className="btn-line" onClick={showModalAddInsurance}>
                    <i className="ic-add"></i>
                    <span>{translations.Insurer?.['Add Insurance Insurer'] || translations.commonMsg?.loading}</span>
                </button>}
            </div>

            <FullPageLoader show={loading} />

            <InsurerListTable apiResponse={insurerList} getInsurerListData={fetchPartnerMappings} loading={loading}  partnerListDropDown={partnerListDropDown} handleLoader={handleLoader} />

            <AddEditInsurer callFrom={'AddInsurer'} showAddInsPartnerIcon={showAddInsPartnerIcon} handleModalClose={hideModalAddInsurance} partnerListDropDown={partnerListDropDown} getInsurerListData={fetchPartnerMappings} fetchPartnerMappings={fetchPartnerMappings} handleLoader={handleLoader} updateSelectedPartner={()=>{}}/>

        </div>
    )
}

